"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPartnerLogo = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../utils/colors");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.2rem;\n  width: ", ";\n  height: ", ";\n  box-sizing: border-box;\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n\n  &:hover {\n    background: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledPartnerLogo = _styledComponents.default.a(_templateObject(), function (props) {
  return props.size || '10em';
}, function (props) {
  return props.size || '10em';
}, function (props) {
  return (0, _colors.getRGBOpacity)(props.theme.colors.brandThemeDark500, 0.15);
});

exports.StyledPartnerLogo = StyledPartnerLogo;